import Styled from 'styled-components'

export default Styled.label`
  display: inline-block;
  font-family: ${props => props.theme.fonts.regular};
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${props => props.theme.colors.gray.shade200};
  margin: 0 0 0.5rem 0;
`



// WEBPACK FOOTER //
// ./src/components/Label/index.js